<onyx-information-heading>
  {{ 'labels.goods' | translate }}
</onyx-information-heading>

<div class="goods">
  @for (good of goods(); track good.uuid) {
    <onyx-data-widget
      [class.span]="$count === 1"
      [headingIcon]="{ name: 'good-filled', size: 20, color: 'black' }"
    >
      <header heading>
        {{ good.type ? (good.type.names | onyxLanguage) : good.typeName }}
      </header>

      <div class="properties">
        <div class="item">
          <p class="label">
            {{ 'labels.goodReferenceNumber' | translate }}
          </p>

          {{ good.referenceNumber ?? '-' }}
        </div>

        <div class="item">
          <p class="label">
            {{ 'labels.unit' | translate }}
          </p>

          {{ good.unit.names | onyxLanguage }}
        </div>

        <div class="item">
          <p class="label">
            {{ 'labels.totalWeight' | translate }}
          </p>

          {{ good.totalWeight | number: '1.0-0' }} kg
        </div>

        @if (good.size; as size) {
          <div class="item">
            <p class="label">
              {{ 'labels.size' | translate }}
            </p>

            @if (size.type === GoodsSizeType.DIMENSIONS) {
              {{ size | dimensions }} ·
            }

            {{ good | goodQuantity }}
          </div>
        }

        @if (good.unitedNationsNumber) {
          <div class="item">
            <p class="label">
              {{ 'labels.unitedNations' | translate }}
            </p>
            <p>{{ good.unitedNationsNumber }}</p>
          </div>
        }

        @if (good.statisticalNumber) {
          <div class="item">
            <p class="label">
              {{ 'labels.statisticalNumber' | translate }}
            </p>
            <p>{{ good.statisticalNumber }}</p>
          </div>
        }
      </div>
    </onyx-data-widget>
  }
</div>
